export default __webpack_public_path__ + "static/media/1033.5a69a5b3.png";